import { IReviewsInfo } from "api/interfaces/product-review.type";

export const initialReviewsInfo: IReviewsInfo = {
  allImages: [],
  reviews: [],
  ratingSnapShot: [
    {
      rating: "star1",
      count: 0,
    },
    {
      rating: "star2",
      count: 0,
    },
    {
      rating: "star3",
      count: 0,
    },
    {
      rating: "star4",
      count: 0,
    },
    {
      rating: "star5",
      count: 0,
    },
  ],
  totalReviewsCount: 0,
  averageRating: 0,
  totalPages: 0,
};
